<template>
  <div class="flex items-center">
    <p>{{ params.value.name_ja || params.value.name_en }}</p>
  </div>
</template>

<script>

  export default {
    name: "CellRendererVesselName",
  };
</script>
